document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-kajyn-product-root]').forEach((root) => {
    const audioPlayers = Array.from(root.querySelectorAll('[data-kajyn-audio-player]'));
    const variantButtons = Array.from(root.querySelectorAll('[data-variant-button]'));
    const variantInput = root.querySelector('[data-kajyn-variant-input]');
    const selectedTitle = root.querySelector('[data-kajyn-selected-title]');
    const selectedPrice = root.querySelector('[data-kajyn-selected-price]');
    const selectedImage = root.querySelector('.kajyn-product-page__selected-image');
    const storePrice = root.querySelector('[data-kajyn-store-price]');
    const submitButton = root.querySelector('[data-kajyn-submit]');
    const quantityInput = root.querySelector('.kajyn-product-page__qty-input');
    const minusButton = root.querySelector('[data-kajyn-qty-minus]');
    const plusButton = root.querySelector('[data-kajyn-qty-plus]');
    const shareButton = root.querySelector('[data-kajyn-share]');
    const previewToggle = root.querySelector('[data-kajyn-contract-preview-toggle]');
    const previewPanel = root.querySelector('[data-kajyn-contract-preview-panel]');
    const previewSelect = root.querySelector('[data-kajyn-contract-preview-select]');
    const contractPreviewLink = root.querySelector('[data-kajyn-contract-preview]');
    const productUrl = root.dataset.productUrl;
    const productTitle = root.dataset.productTitle || document.title;
    const contractPreviewBaseUrl = root.dataset.contractPreviewBaseUrl || '';
    const summaryUnit = root.querySelector('[data-kajyn-summary-unit]');
    const summaryTotal = root.querySelector('[data-kajyn-summary-total]');
    const formatMoney = (cents) => `€${((Number(cents) || 0) / 100).toFixed(2)}`;
    const closePreviewPanel = () => {
      if (!previewToggle || !previewPanel) return;

      previewToggle.setAttribute('aria-expanded', 'false');
      previewPanel.hidden = true;
    };

    const getActiveVariantButton = () => root.querySelector('[data-variant-button].is-active') || variantButtons[0];

    const formatAudioTime = (seconds) => {
      const safeSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
      const minutes = Math.floor(safeSeconds / 60);
      const remainingSeconds = safeSeconds % 60;
      return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const setAudioProgress = (player, audio, progressInput, currentLabel, durationLabel) => {
      const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
      const currentTime = Number.isFinite(audio.currentTime) ? audio.currentTime : 0;
      const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;

      if (progressInput) {
        progressInput.value = String(progressPercent);
        progressInput.style.setProperty('--kajyn-audio-progress', `${progressPercent}%`);
      }

      if (currentLabel) currentLabel.textContent = formatAudioTime(currentTime);
      if (durationLabel) durationLabel.textContent = formatAudioTime(duration);

      player.classList.toggle('is-playing', !audio.paused);
    };

    const updateContractPreview = () => {
      if (!contractPreviewLink || !contractPreviewBaseUrl) return;

      const activeButton = getActiveVariantButton();
      const previewFile = previewSelect?.value || activeButton?.dataset.previewPdfFile || 'basic-lease-preview.pdf';
      const baseUrl = contractPreviewBaseUrl.replace(/\/+$/, '');
      contractPreviewLink.href = `${baseUrl}/${previewFile}`;
    };

    const syncPreviewSelectToVariant = () => {
      if (!previewSelect) return;

      const activeButton = getActiveVariantButton();
      const previewFile = activeButton?.dataset.previewPdfFile || 'basic-lease-preview.pdf';
      const matchingOption = Array.from(previewSelect.options).find((option) => option.value === previewFile);
      if (matchingOption) {
        previewSelect.value = matchingOption.value;
      }
    };

    const updateSummary = () => {
      const activeButton = getActiveVariantButton();
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const unitCents = Number(activeButton?.dataset.variantPriceCents || 0);

      if (summaryUnit) summaryUnit.textContent = formatMoney(unitCents);
      if (summaryTotal) summaryTotal.textContent = formatMoney(unitCents * quantity);
    };

    const updateVariant = (button) => {
      if (!button || !variantInput) return;

      variantButtons.forEach((item) => item.classList.toggle('is-active', item === button));
      variantInput.value = button.dataset.variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (selectedTitle) selectedTitle.textContent = button.dataset.variantTitle || 'Standard purchase';
      if (selectedPrice) selectedPrice.textContent = button.dataset.variantPrice || selectedPrice.textContent;
      if (storePrice) storePrice.textContent = button.dataset.variantPrice || storePrice.textContent;
      if (selectedImage && button.dataset.variantImage) selectedImage.src = button.dataset.variantImage;
      if (submitButton) {
        const available = button.dataset.variantAvailable === 'true';
        submitButton.disabled = !available;
        const label = submitButton.querySelector('span');
        if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
      }

      if (productUrl) {
        window.history.replaceState({}, '', button.dataset.variantUrl || `${productUrl}?variant=${button.dataset.variantId}`);
      }

      updateSummary();
      syncPreviewSelectToVariant();
      updateContractPreview();
    };

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => updateVariant(button));
    });

    minusButton?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      updateSummary();
    });

    plusButton?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      updateSummary();
    });

    quantityInput?.addEventListener('input', () => {
      if (Number(quantityInput.value || 0) < 1) quantityInput.value = 1;
      updateSummary();
    });

    shareButton?.addEventListener('click', async () => {
      const url = window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ title: document.title, url });
          return;
        } catch (_error) {}
      }
      try {
        await navigator.clipboard.writeText(url);
        const shareLabel = shareButton.textContent;
        shareButton.textContent = shareButton.dataset.copiedLabel || 'Link copied';
        setTimeout(() => {
          shareButton.textContent = shareLabel;
        }, 1600);
      } catch (_error) {}
    });

    previewToggle?.addEventListener('click', () => {
      const nextExpanded = previewToggle.getAttribute('aria-expanded') !== 'true';
      previewToggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      if (previewPanel) {
        previewPanel.hidden = !nextExpanded;
      }
    });

    previewSelect?.addEventListener('change', updateContractPreview);

    document.addEventListener('click', (event) => {
      if (!previewToggle || !previewPanel) return;
      if (previewToggle.contains(event.target) || previewPanel.contains(event.target)) return;

      closePreviewPanel();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      closePreviewPanel();
    });

    audioPlayers.forEach((player) => {
      const audio = player.querySelector('[data-kajyn-audio-element]');
      const toggle = player.querySelector('[data-kajyn-audio-toggle]');
      const progressInput = player.querySelector('[data-kajyn-audio-progress]');
      const currentLabel = player.querySelector('[data-kajyn-audio-current]');
      const durationLabel = player.querySelector('[data-kajyn-audio-duration]');
      const volumeWrap = player.querySelector('[data-kajyn-audio-volume]');
      const volumeToggle = player.querySelector('[data-kajyn-audio-volume-toggle]');
      const volumeRange = player.querySelector('[data-kajyn-audio-volume-range]');

      if (!audio || !toggle || !progressInput) return;

      const syncPlayer = () => setAudioProgress(player, audio, progressInput, currentLabel, durationLabel);
      const syncVolume = () => {
        const volume = audio.muted ? 0 : audio.volume;
        const volumePercent = Math.round(Math.max(0, Math.min(1, volume)) * 100);

        if (volumeRange) {
          volumeRange.value = String(volumePercent);
          volumeRange.style.setProperty('--kajyn-volume-progress', `${volumePercent}%`);
        }

        if (volumeWrap) volumeWrap.classList.toggle('is-muted', volumePercent === 0);
        if (volumeToggle) {
          volumeToggle.setAttribute('aria-pressed', volumePercent === 0 ? 'true' : 'false');
          volumeToggle.setAttribute('aria-label', volumePercent === 0 ? 'Unmute volume' : 'Mute volume');
        }
      };

      audio.preload = 'metadata';
      audio.volume = 0.8;
      audio.playbackRate = 1;
      audio.defaultPlaybackRate = 1;
      audio.preservesPitch = true;
      audio.disableRemotePlayback = true;

      toggle.addEventListener('click', async () => {
        if (audio.paused) {
          audioPlayers.forEach((otherPlayer) => {
            if (otherPlayer === player) return;
            const otherAudio = otherPlayer.querySelector('[data-kajyn-audio-element]');
            if (otherAudio) {
              otherAudio.pause();
              otherPlayer.classList.remove('is-playing');
            }
          });

          try {
            await audio.play();
          } catch (_error) {}
        } else {
          audio.pause();
        }
        syncPlayer();
      });

      progressInput.addEventListener(
        'input',
        () => {
          const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
          const progressPercent = Number(progressInput.value || 0);
          if (duration > 0) {
            audio.currentTime = (progressPercent / 100) * duration;
          }
          syncPlayer();
        },
      );

      audio.addEventListener('loadedmetadata', syncPlayer);
      audio.addEventListener('timeupdate', syncPlayer);
      audio.addEventListener('play', syncPlayer);
      audio.addEventListener('pause', syncPlayer);
      audio.addEventListener('volumechange', syncVolume);
      audio.addEventListener('ended', () => {
        audio.currentTime = 0;
        syncPlayer();
      });
      audio.addEventListener('ratechange', () => {
        if (audio.playbackRate !== 1) {
          audio.playbackRate = 1;
        }
      });

      volumeToggle?.addEventListener('click', () => {
        if (audio.muted || audio.volume === 0) {
          audio.muted = false;
          if (audio.volume === 0) audio.volume = 0.8;
        } else {
          audio.muted = true;
        }
        syncVolume();
      });

      volumeRange?.addEventListener('input', () => {
        const nextVolume = Math.max(0, Math.min(1, Number(volumeRange.value || 0) / 100));
        audio.muted = nextVolume === 0;
        audio.volume = nextVolume;
        syncVolume();
      });

      syncPlayer();
      syncVolume();
    });

    updateSummary();
    syncPreviewSelectToVariant();
    updateContractPreview();
  });
});
